// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { postChallengeReviews } from '../../apis/challenge';
import { postChallengeReviewsActions } from '../actionCreators/postChallengeReviewsActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: postChallengeReviewsActions.success,
  failure: postChallengeReviewsActions.failure
};

type RequestActionTypes = ActionType<
  typeof postChallengeReviewsActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const postChallengeReviewsEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(postChallengeReviewsActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, condition, ...others } = action.payload;
      // send api promise
      return postChallengeReviews(id, others, condition)
        .then(() => {
          // handle success case here
          return postChallengeReviewsActions.success();
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return postChallengeReviewsActions.failure({ error });
        });
    })
  );
};
